import React from 'react'
import { Resource } from 'react-admin';

import ProductHierarchy from  './product_hierarchy'
import Broker from './broker'
import Director from './director'
import Regional from './regional'

import ChainPriority from './chain_priority'

const Resources = [
    <Resource name='lil_drug_chain_to_chain_mapping' />,

    <Resource {...ProductHierarchy}/>,

    <Resource {...ChainPriority}/>,
    <Resource name='lil_drug_chain_priority_chain_mapping' />,

    <Resource {...Broker}/>,
    <Resource name='lil_drug_broker_chain_mapping' />,
    <Resource name='lil_drug_broker_warehouse_mapping' />,

    <Resource {...Director}/>,
    <Resource name='lil_drug_director_chain_mapping' />,
    <Resource name='lil_drug_director_warehouse_mapping' />,

    <Resource {...Regional}/>,
    <Resource name='lil_drug_regional_chain_mapping' />,
    <Resource name='lil_drug_regional_warehouse_mapping' />,
    
]

export default Resources